import api from './api';

const TagDinamicaService = {
    index: () => {
      return api.get(`/tag-dinamica`);
    },
};

export default TagDinamicaService;
